import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { QuoteState } from '@nibtravel/shared/data-access/quote';
import {
  QuoteConfigState,
  QuoteConfigStateModel,
} from '@nibtravel/shared/data-access/quote-config';
import {
  IPolicyHolderAgeConfig,
  QuoteType,
} from '@nibtravel/shared/util/models';

@Injectable({ providedIn: 'root' })
export class AgeAmbiguitySelector {
  @Selector([QuoteState.homeCountry, QuoteState.quoteType, QuoteConfigState])
  static policyHolderConfig(
    homeCountry: string | undefined,
    quoteType: QuoteType,
    quoteConfig: QuoteConfigStateModel
  ): IPolicyHolderAgeConfig {
    return homeCountry
      ? quoteConfig[quoteType]?.policyHolderAgeConfigsMap[homeCountry] || {}
      : ({} as IPolicyHolderAgeConfig);
  }

  @Selector([AgeAmbiguitySelector.policyHolderConfig])
  static maxDependentAge(policyHolderConfig: IPolicyHolderAgeConfig): number {
    return policyHolderConfig.maxDependentAge;
  }
}
